// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tip-dialog .el-dialog__header{padding:16px 20px;border-bottom:1px solid #ddd}.tip-dialog .el-dialog__footer{padding:0 20px 30px}", ""]);
// Exports
module.exports = exports;
